// user pages
import Opportunities from "../Mycomponent/pages/opportunities";
import History from "../Mycomponent/pages/Search-History/history";
import OnBoarding from "../Mycomponent/pages/OnBoard";
import WhiteLabel from "../Mycomponent/pages/Account/WhiteLabel";
import WhiteLabelCustomDomain from "../Mycomponent/pages/Account/WhiteLabelCustomDomain";
import OrganicKeywords from "../Mycomponent/pages/site-overview/OrganicKeywords";
import AIOKeywords from "../Mycomponent/pages/site-overview/AIOKeywords";
// admin pages
import CancelPlan from "../admin/pages/Add-on-plans/CancelPlan";
import UserServices from "../admin/pages/USER/UserServices";

import { USER_ROUTES, ADMIN_ROUTES } from "./constant";

// user layout routes
export const USER_NAVROUTES = [
  {
    path: USER_ROUTES.Page.opportunities,
    component: Opportunities,
    isLoginRequire: true,
    isPlanRequire: true,
    isProjectRequire: true,
  },
  {
    path: USER_ROUTES.Page.history,
    component: History,
    useSeo: true,
    isLoginRequire: true,
    isPlanRequire: true,
    isProjectRequire: false,
  },
  {
    path: USER_ROUTES.Page.whitelabel,
    component: WhiteLabel,
    useSeo: true,
    isLoginRequire: true,
    isPlanRequire: true,
    isProjectRequire: false,
  },
  {
    path: USER_ROUTES.Page.whitelabeldomain,
    component: WhiteLabelCustomDomain,
    useSeo: true,
    isLoginRequire: true,
    isPlanRequire: true,
    isProjectRequire: false,
  },
  {
    path: USER_ROUTES.Page.organickeywords,
    component: OrganicKeywords,
    useSeo: true,
    isLoginRequire: true,
    isPlanRequire: true,
    isProjectRequire: false,
  },
  {
    path: USER_ROUTES.Page.aiokeywords,
    component: AIOKeywords,
    useSeo: true,
    isLoginRequire: true,
    isPlanRequire: true,
    isProjectRequire: false,
  },
];

// routes accessable in every conditions
export const FREE_NAVROUTES = [
  {
    path: USER_ROUTES.Page.onboard,
    component: OnBoarding,
    useSeo: false,
    isAccessable: true,
  },
];

// admin routes
export const ADMIN_NAVROUTES = [
  {
    path: ADMIN_ROUTES.Page.cancel_plan,
    component: CancelPlan,
  },
  {
    path: ADMIN_ROUTES.Page.user_services,
    component: UserServices,
  },
];
